{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "Spring Boot 1.x Anwendungen unterstützen keine Audit-Logs.",
      "event": "Ereignis",
      "loading_audit_events": "Audit-Events werden geladen...",
      "no_audit_events_found": "Keine Audit-Events vorhanden.",
      "principal": "Prinzipal",
      "remote_address": "Remote address",
      "session_id": "Session Id",
      "timestamp": "Zeitstempel",
      "type": "Typ",
      "label": "Audit-Protokoll"
    }
  }
}
